import React from "react"
import PropTypes from "prop-types"
import NePasManquerItem from "gatsby-theme-cactus/src/gatsby-theme-blank/components/Home/NePasManquer/NePasManquerItem/ne-pas-manquer-item"
import { CustomArrows } from "./render-ne-pas-manquer-styled"
import MultiCarousel from "react-multi-carousel"
import {
  nePasManquerCarousel,
  carouselArrowRight,
  carouselArrowLeft,
} from "../ne-pas-manquer.module.scss"

const RenderNePasManquer = ({ nePasManquerData }) => {
  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 900 },
      items: 3,
    },
    mobile: {
      breakpoint: { max: 900, min: 0 },
      items: 2,
    },
  }
  return (
    <MultiCarousel
      className={nePasManquerCarousel}
      transitionDuration={500}
      customRightArrow={<CustomRightArrow />}
      customLeftArrow={<CustomLeftArrow />}
      responsive={responsive}
      infinite={true}
      arrows={true}
    >
      {nePasManquerData.map(({ node }) => {
        return <NePasManquerItem key={node.drupal_id} nePasManquer={node} />
      })}
    </MultiCarousel>
  )
}

const CustomRightArrow = ({ onClick }) => {
  // onMove means if dragging or swiping in progress.
  return (
    <CustomArrows
      className={carouselArrowRight}
      style={{
        right: "calc(4% + 1px)",
      }}
      onClick={() => onClick()}
    />
  )
}
const CustomLeftArrow = ({ onClick }) => {
  // onMove means if dragging or swiping in progress.
  return (
    <CustomArrows
      className={carouselArrowLeft}
      style={{
        left: "calc(4% + 1px)",
      }}
      onClick={() => onClick()}
    />
  )
}
RenderNePasManquer.propTypes = {
  nePasManquerData: PropTypes.object.isRequired,
}
CustomRightArrow.propTypes = {
  onClick: PropTypes.func,
}
CustomLeftArrow.propTypes = {
  onClick: PropTypes.func,
}

export default RenderNePasManquer
